// library
import $ from 'jquery'
global.$ = jQuery
const Rails = require('@rails/ujs')
const moment = require('moment')
const images = require.context('../img', true)
const imagePath = (name) => images(name, true)

// setup vendor
import '../js/vendor/bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../js/vendor/rails_data_confirm'
import '../js/users/events'
import '../../assets/javascripts/pages/searches'
import '../../assets/javascripts/users/ajax_sortable'
import '../../../vendor/assets/javascripts/daterangepicker.min'
import bootbox from 'bootbox'

// library
import '../js/library/push_notification'

// styling
import '../styles/application'
import '../../../vendor/assets/stylesheets/daterangepicker.css'
window.bootbox = bootbox

Rails.start()
